import { createAdapterSucursal } from "../../../adapter/sucursalAdapter";
import { getAsync } from "../httpServiceIntelafApi";

const URI = '/Sucursal';

export const getSucursalesAsync = () => {
    return getAsync(URI, {}).then((sucursales) => { 
        return sucursales.map(sucursal => createAdapterSucursal(sucursal)); 
    });
}